module.exports = __webpack_public_path__ + "static/media/3.ca33f5dd.webp";